// Single source of truth for keyboard shortcuts. Both the toolbar (which
// renders aria-keyshortcuts attrs) and the orchestrator (which calls
// bindShortcuts) import from here so collisions are prevented mechanically.
//
// Future sub-fasi (4.F camera presets / 4.J measurements / etc.) MUST
// extend this registry rather than introduce new literals scattered around.
//
// Step 7: `screenshot` and `measure` entries are kept for the toolbar
// (button keys) but are NO LONGER bound to the keyboard. Reason: 's' and
// 'd' collide with WASD walk movement (S = backward, D = right-strafe)
// and accidentally trigger the feature mid-walk. Both features remain
// reachable from the toolbar buttons.
export const SHORTCUTS = Object.freeze({
  fullscreen: 'f',
  screenshot: 's',
  reset: 'r',
  perf: 'p',
  share: 'c', // 'c' for "copia/condividi"
  tour: 't', // 4.F: toggle guided tour (start when idle, exit when active)
  hotspots: 'h', // 4.G: toggle hotspot dots/strip visibility (closes popup)
  floorplan: 'm', // 4.H: toggle floor plan minimap visibility ('m' for "Mappa")
  measure: 'd', // 4.J: toggle measurement mode ('d' for "distanza"; 'r' is reset view)
  walk: 'v', // 4.I1: toggle walk mode ('v' for "vista"; 'w' is movement key in WASD)
  xr: 'x', // 4.K: toggle WebXR modal / exit session ('x' for "XR")
} as const);

export type ShortcutKey = keyof typeof SHORTCUTS;
